import { TriggerType, WebApiStrategyOrderExeType } from '../../../../utProto/webApiStrategyEnums_pb';
import { OrderValidity } from '../../../../utProto/enums_pb';
import { Utils } from '@app/_helpers';
export enum REPAIR_TYPE {
    REPAIR_ONCE = 'Repair once',
    REPAIR_CONTINUOUS = 'Repair continuous',
    REPAIR_NEVER = 'NEVER'
}

export const SAVE_ONLY_DEPLOY = -1;

export enum CANDLE_OPTIONS {
    //continuous = 'Continuous', //to be handled later(RA-383)
    oneM = '1 min',
    fiveM = '5 min',
    temM = '10 min',
    fifteenM = '15 min',
    thirtyM = '30 min',
    oneH = '1 hour',
    oneD = '1 day'
}

export const CANDLE_MINUTES_MAPPING = new Utils.TwoWAyDict({
    '1 min': 1,
    '3 min': 3,
    '5 min': 5,
    '10 min': 10,
    '15 min': 15,
    '30 min': 30,
    '1 hour': 60,
    '1 day': 1440
}).getDict();

export enum REACTIVATE_OPTIONS {
    continuous = 'Continuous',
    never = 'Never',
    twoM = '2 min',
    fiveM = '5 min',
    tenM = '10 min',
    thirtyM = '30 min',
    oneH = '1 hour',
    twoH = '2 hours',
    fiveH = '5 hours',
    sixH = '6 hours',
    twelveH = '12 hours',
    oneD = '1 day',
    sevenD = '7 days',
    thirtyD = '30 days',
    ninetyD = '90 days',
    oneEyyD = '180 days',
    thsxfvD = '365 days'
}

export const REACTIVE_OPTIONS_MAPPING = new Utils.TwoWAyDict({
    'Continuous': 0,
    '1 min': 1,
    '2 min': 2,
    '3 min': 3,
    '5 min': 5,
    '10 min': 10,
    '15 min': 15,
    '30 min': 30,
    '60 min': 60,
}).getDict();


export enum AND_OR {
    AND = 'AND',
    OR = 'OR'
}

// Commented Comparators are not supported by backend yet. Commented for fixing RA-302
export enum COMPARATORS {
    crossesAbove = 'Crosses above',
    crossesBelow = 'Crosses below',
    // downBy = 'Down by',
    equalTo = 'Equal to',
    greaterThan = 'Greater than',
    greaterThanEQ = 'Greater than equal to',
    lowerThan = 'Lower than',
    lowerThanEQ = 'Lower than equal to',
    // upBy = 'Up by',
}

export const COMPARATORS_MAPPING = {
    'Crosses above': '↗',
    'Crosses below': '↘',
    'Equal to': '=',
    'Greater than': '>',
    'Greater than equal to': '>=',
    'Lower than': '<',
    'Lower than equal to': '<='
}

export enum PRODUCT_TYPE {
    INTRADAY = 'Intraday',
    DELIVERY = 'Delivery',
    CARRYFORWARD = 'Carryforward'
}

export const PRODUCT_TYPE_TWO_WAY = new Utils.TwoWAyDict({
    'Intraday': 'INTRADAY',
    'Delivery': 'DELIVERY',
}).getDict();

export enum EXECUTION_STYLE {
    OFFLINE = 'Alerts Only',
    SEMI_AUTOMATED = 'One touch execution',
    FULLY_AUTOMATED = 'Direct execution'
}

export enum EXECUTION_STYLE_NUM {
    OFFLINE = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_OFFLINE,
    SEMI_AUTOMATED = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_SEMI_AUTOMATED,
    FULLY_AUTOMATED = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_AUTOMATED,
    DEPENDENT = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_EVENT_BASED
}

export enum PRICE_METHOD {
    HIT_BID_ASK = 'Hit bid/ask',
    BEST_BID_ASK = 'Best bid/ask',
    MARKET_ORDER = 'Market Order',
    AVERAGE_BID_ASK = 'Average bid/ask',
    LTP = 'LTP'
}

export enum FINAL_EXECUTION_METHOD {
    MARKET_ORDER = 'Market Order',
    DELETE = 'Delete',
    IGNORE = 'Ignore'
}

export enum ORDER_MODE {
    BUY = "Buy",
    SELL = "Sell"
}

export enum StrategyFormBuildMode {
    TEXT_BUILDER = 'Text Builder Mode',
    REGULAR = 'Regular',
    PRO = 'Pro',
    WIZARD = 'Wizard'
}

// Temp enum, will eventually be removed
export enum StrategyFormBuildModeTemp {
    REGULAR = 'Regular',
    PRO = 'Pro',
    WIZARD = 'Wizard'
}

export enum ChartType {
    CANDLESTICK = 'Candlestick',
    // RA-1365: chart-type not yet implemented, commenting it to remove from select drop-down
    // un-comment when feature is implemention is complete.
    // HEIKEN_ASHI = 'Heiken Ashi'
}


export enum TriggerTypeEnum {
    'EN' = TriggerType.TRIGGERTYPE_CONDITIONAL_ENTRY,
    'SL' = TriggerType.TRIGGERTYPE_STOP_LOSS_EXIT,
    'TP' = TriggerType.TRIGGERTYPE_TARGET_PROFIT_EXIT,
    'CE' = TriggerType.TRIGGERTYPE_CONDITIONAL_EXIT,
    'SLR' = TriggerType.TRIGGERTYPE_STOP_LOSS_REPAIR,
    'TFR' = TriggerType.TRIGGERTYPE_TARGET_PROFIT_REPAIR,
    'CR' = TriggerType.TRIGGERTYPE_CONDITIONAL_REPAIR,
    'SO' = TriggerType.TRIGGERTYPE_SQUARE_OFF,
    'Range Breached' = TriggerType.TRIGGERTYPE_TARGET_PROFIT_RANGE_EXIT,
    'LP' = TriggerType.TRIGGERTYPE_LOCKED_PROFIT_EXIT,
    'MSO' = TriggerType.TRIGGERTYPE_MULTIPLIER_SQUARE_OFF,
}

export enum OrderValidityEnum {
    'DAY' = OrderValidity.ORDERVALIDITY_DAY,
    'IOC' = OrderValidity.ORDERVALIDITY_IOC
}

export enum IndicatorDisplayType {
    NOT_REQUIRED,
    DROPDOWN,
    FLOAT,
    INTEGER
}


export const PRICE_METHOD_MAPPING = new Utils.TwoWAyDict({
    'Average bid/ask': 6,
    'Best bid/ask': 1,
    'Hit bid/ask': 2,
    'Market Order': 9,
    'Limit': 0,
    'LTP': 10
}).getDict();

export enum MAX_DEPTH_TYPE {
    ITM = 0,
    OTM = 1,
    BOTH = 2,
    DIFF = 3
}